// Projects that can be displayed without boards (whitelist)
// These projects will be shown in navigation even if they don't have boards
// Only applies in production version
export const PROJECTS_WITHOUT_BOARDS_WHITELIST = [
  167, // hallmark-one
  173, // hallmark-media
  174, // hallmark-retail
];

// Helper function to check if a project should be displayed
export function shouldDisplayProject(project, version) {
  const hasBoards = project.boards && project.boards.length > 0;
  // Convert project.id to number for comparison since whitelist contains numbers
  const projectId = parseInt(project.id, 10);
  const isWhitelisted = PROJECTS_WITHOUT_BOARDS_WHITELIST.includes(projectId);
  const isDevelopment = version === "development";
  const isProduction = !isDevelopment; // If not development, consider it production

  // If project has boards, always show it
  if (hasBoards) {
    return true;
  }

  // If project is whitelisted and we're in production, show it regardless of its version field
  if (isWhitelisted && isProduction) {
    return true;
  }

  return false;
}
